import React from "react";
import { formatINRCurrency } from "../../../../utilities/currency/currency";
import { getFormattedDateDDMMMYYYYDate } from "../../../../utilities/dateFunctions/formatdate";

const PreOtsNotice = ({
  otsCalculation,
  otsDate,
  selectedApplicantDetails,
  setSelectedRefrenceNumber,
}) => {
  console.log(selectedApplicantDetails);

  return (
    <>
      <section>
        <div className="w-full flex justify-center">
          <div className="bg-white p-8 w-[800px] text-sm leading-relaxed">
            {/* Reference and Date */}
            <div className="flex justify-between mb-6">
              <p>Ref No. {setSelectedRefrenceNumber || "N/A"}</p>
              <p>Dated: {getFormattedDateDDMMMYYYYDate(otsDate)}</p>
            </div>

            {/* To Section */}
            <div className="mb-3">
              <p>To,</p>
              <div className="mt-2 font-semibold">
                <p>{selectedApplicantDetails?.applicantname || ""}</p>
                <p>
                  {selectedApplicantDetails?.applicantrelative || ""}{" "}
                  {selectedApplicantDetails?.applicantrelativename || ""}
                </p>
                <p>{selectedApplicantDetails?.permanentaddress || ""}</p>
                <p>Mobile#: {selectedApplicantDetails?.contactno || ""}</p>
              </div>
            </div>

            {/* Subject */}
            <p className="font-semibold mb-2 underline">
              Subject: One Time Settlement (OTS) Scheme for Loan I. D. No.{" "}
              {selectedApplicantDetails?.loanee_id || "n/a"}
            </p>

            {/* Body Text */}
            <p className="mb-2">
              Dear{" "}
              {selectedApplicantDetails?.applicantgender == "Female"
                ? "Madam"
                : "Sir"}
              ,
            </p>

            <p className="mb-2">
              We are pleased to inform you that this Corporation has introduced
              a One Time Settlement (OTS) Scheme for loans availed prior to
              31.03.2015 on case to case basis. Your loan account bearing ID No{" "}
              {selectedApplicantDetails?.loanee_id || "n/a"} is eligible under
              this scheme.
            </p>

            <p className="mb-2">
              Under the scheme, while the principal loan amount remains payable
              in full, a {otsCalculation?.waiver_rate || "n/a"}% waiver on the
              outstanding interest component is being offered as part of a full
              and final settlement of your loan.
            </p>

            <p className="mb-2">
              You are requested to visit this office at the earliest to take
              advantage of this opportunity.
            </p>

            {/* Loan Particulars */}
            <p className="font-semibold mb-2">Loan Particulars</p>

            <div className="w-full flex items-center justify-center">
              <table className="w-full mb-1 border border-slate-300 rounded-lg">
                <tbody>
                  {/* Header */}
                  <tr className="bg-slate-100 border-b border-slate-300">
                    <td className="py-2 px-3 font-semibold border-r border-slate-300">
                      Particulars
                    </td>
                    <td className="py-2 px-3 font-semibold">Amount (Rs.)</td>
                  </tr>

                  <tr className="border-b border-slate-200">
                    <td className="py-2 px-3 border-r border-slate-200">
                      Principal outstanding due
                    </td>
                    <td className="py-2 px-3">
                      {formatINRCurrency(otsCalculation?.outstanding_amt || 0)}
                    </td>
                  </tr>

                  <tr className="border-b border-slate-200">
                    <td className="py-2 px-3 border-r border-slate-200">
                      Simple Interest
                    </td>
                    <td className="py-2 px-3">
                      {formatINRCurrency(
                        otsCalculation?.interest_due_amount || 0
                      )}
                    </td>
                  </tr>

                  <tr className="border-b border-slate-200">
                    <td className="py-2 px-3 border-r border-slate-200">
                      Penal Interest
                    </td>
                    <td className="py-2 px-3">
                      {formatINRCurrency(otsCalculation?.penal_int_due || 0)}
                    </td>
                  </tr>

                  <tr className="border-b border-slate-200">
                    <td className="py-2 px-3 border-r border-slate-200">
                      Interest on Interest
                    </td>
                    <td className="py-2 px-3">
                      {formatINRCurrency(otsCalculation?.ioi_int_due || 0)}
                    </td>
                  </tr>

                  <tr className="border-b border-slate-200 bg-slate-50">
                    <td className="py-2 px-3 font-semibold border-r border-slate-300">
                      Total
                    </td>
                    <td className="py-2 px-3 font-semibold">
                      {formatINRCurrency(
                        +(otsCalculation?.outstanding_amt || 0) +
                          +(otsCalculation?.interest_due_amount || 0) +
                          +(otsCalculation?.penal_int_due || 0) +
                          +(otsCalculation?.ioi_int_due || 0)
                      )}
                    </td>
                  </tr>

                  <tr className="border-b border-slate-200">
                    <td className="py-2 px-3 border-r border-slate-200">
                      Less: {otsCalculation?.waiver_rate || "n/a"}% concession
                      on Interest
                    </td>
                    <td className="py-2 px-3">
                      {formatINRCurrency(otsCalculation?.waiver_amount || 0)}
                    </td>
                  </tr>

                  <tr>
                    <td className="py-2 px-3 font-semibold border-r border-slate-300">
                      Net Payable Amount
                    </td>
                    <td className="py-2 px-3 font-semibold">
                      {formatINRCurrency(
                        +(otsCalculation?.outstanding_amt || 0) +
                          +(otsCalculation?.interest_due_amount || 0) +
                          +(otsCalculation?.penal_int_due || 0) +
                          +(otsCalculation?.ioi_int_due || 0) -
                          (otsCalculation?.waiver_amount || 0)
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Additional Notes */}
            <p className="mb-1">
              You may also deposit the settlement amount or instalments at any
              nearby branch of SISCO Bank by providing your Name and Loan ID
              Number.
            </p>

            <p className="mb-1">
              Please note that this offer will stand automatically lapsed if no
              action is taken within the offer period. After expiry of the
              scheme, SABCCO reserves the right to recover the full dues along
              with applicable interest.
            </p>

            <p className="mb-1">We look forward to your early response.</p>

            {/* Footer */}
            <p className="mt-5">Thanking you,</p>
            <p>Yours faithfully,</p>

            <p className="mt-20">Dy. General Manager</p>
            <p className="">SABCCO</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default PreOtsNotice;
